<template>
    <div class="root">
        <header class="header h-12">
            <button @click="asideStore.showAside()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M18 18V20H6V18H18ZM21 11V13H3V11H21ZM18 4V6H6V4H18Z"></path>
                </svg>
            </button>
            <h1>智慧农业</h1>
            <button @click="chatStore.newChat()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path
                        d="M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM10 3H14V5H10C6.68629 5 4 7.68629 4 11C4 14.61 6.46208 16.9656 12 19.4798V17H14C17.3137 17 20 14.3137 20 11H22C22 15.4183 18.4183 19 14 19V22.5C9 20.5 2 17.5 2 11C2 6.58172 5.58172 3 10 3Z"
                    ></path>
                </svg>
            </button>
        </header>
        <main v-if="route.path !== '/'" ref="main" class="main h-full">
            <MessageItem
                v-for="(item, index) in data.messageList"
                :key="index"
                :item="item"
                :index="index"
                :is-waiting="data.isWaiting"
                :is-last="index === data.messageList.length - 1"
                :is-thinking="data.isThinking"
                @edit="handleEditMessage(index)"
            />
            <div class="w-full h-1/5">
                <!-- 占位让footer不遮挡main -->
            </div>
        </main>
        <main v-else ref="main" class="main h-full flex justify-center items-start">
            <h1 class="text-3xl mt-56">What can I help with?</h1>
        </main>

        <footer class="w-full fixed bottom-0 flex flex-col items-center justify-center bg-white">
            <form
                class="w-5/6 border rounded-md border-gray-300 p-2 shadow align-top relative"
                @submit.prevent="handleSendMessage"
            >
                <!-- <div class="virtual-box"></div> -->
                <Editor v-show="!data.isSpeaking" v-model="data.inputValue" class="w-full" placeholder="请输入内容" />
                <canvas v-show="data.isSpeaking" ref="canvasEl" class="w-full h-10" width="300" height="40"></canvas>
                <div class="w-full flex flex-row justify-between items-center mt-2 h-4">
                    <div class="flex flex-row items-center w-auto">
                        <van-uploader :preview-image="false" :max-count="5" :after-read="onAfterRead" accept="image/*">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path
                                    d="M15 8V4H5V20H19V8H15ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8C10.3284 8 11 8.67157 11 9.5ZM17.5 17L13.5 10L8 17H17.5Z"
                                ></path>
                            </svg>
                        </van-uploader>
                    </div>
                    <div v-if="!data.isSpeaking" class="flex flex-row items-center w-auto">
                        <button type="button" class="mr-px" @click="handleSpeak">
                            <svg
                                class="w-4 h-4"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M18.9953 11.5415C19.5246 11.6991 19.826 12.2559 19.6685 12.7852C18.7771 15.7804 16.179 18.0417 13 18.4381V19.5H14.5C15.0523 19.5 15.5 19.9477 15.5 20.5C15.5 21.0523 15.0523 21.5 14.5 21.5H9.50002C8.94773 21.5 8.50002 21.0523 8.50002 20.5C8.50002 19.9477 8.94773 19.5 9.50002 19.5H11V18.4381C7.82093 18.0418 5.22279 15.7805 4.33136 12.7852C4.17382 12.2559 4.47522 11.6991 5.00456 11.5415C5.5339 11.384 6.09073 11.6854 6.24827 12.2148C6.98609 14.6939 9.28339 16.5 11.9999 16.5C14.7165 16.5 17.0138 14.6939 17.7516 12.2148C17.9091 11.6854 18.466 11.384 18.9953 11.5415Z"
                                    fill="currentColor"
                                ></path>
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M14.5 10.5V7C14.5 5.61929 13.3807 4.5 12 4.5C10.6193 4.5 9.5 5.61929 9.5 7V10.5C9.5 11.8807 10.6193 13 12 13C13.3807 13 14.5 11.8807 14.5 10.5ZM12 2.5C9.51472 2.5 7.5 4.51472 7.5 7V10.5C7.5 12.9853 9.51472 15 12 15C14.4853 15 16.5 12.9853 16.5 10.5V7C16.5 4.51472 14.4853 2.5 12 2.5Z"
                                    fill="currentColor"
                                ></path>
                            </svg>
                        </button>
                        <button type="submit">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path
                                    d="M21.7267 2.95694L16.2734 22.0432C16.1225 22.5716 15.7979 22.5956 15.5563 22.1126L11 13L1.9229 9.36919C1.41322 9.16532 1.41953 8.86022 1.95695 8.68108L21.0432 2.31901C21.5716 2.14285 21.8747 2.43866 21.7267 2.95694ZM19.0353 5.09647L6.81221 9.17085L12.4488 11.4255L15.4895 17.5068L19.0353 5.09647Z"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div v-else class="flex flex-row items-center w-auto">
                        <button type="button" class="mr-px" @click="finishSpeak">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                                fill="currentColor"
                            >
                                <path
                                    d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"
                                ></path>
                            </svg>
                        </button>
                        <button type="submit" class="" @click="cancelSpeak">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                                fill="currentColor"
                            >
                                <path
                                    d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div
                        class="absolute left-0 top-0 w-full h-10 flex flex-row justify-start items-center mb-2 transform -translate-y-full"
                    >
                        <div v-for="(img, index) in data.imageList" :key="index" class="relative group">
                            <img :src="img.url" class="w-full h-10 object-cover rounded shadow border" />
                            <button class="absolute top-0 right-0 h-4 w-4" @click="removeImage(index)">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgba(255,0,0,1)">
                                    <path
                                        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </form>

            <p class="text-sm font-thin text-neutral-300">AI-generated content, for reference only</p>
        </footer>
    </div>
    <van-popup v-model:show="data.showEdit" style="padding: 10px; overflow: hidden; height: 60vh">
        <Editor v-if="data.showEdit" v-model="data.editValue" class="w-full border-2" placeholder="请输入内容" />
        <div class="w-full flex gap-2 justify-around">
            <van-button type="danger" class="w-full mt-4" @click="cancelEdit">取消</van-button>
            <van-button type="primary" class="w-full mt-4" @click="confirmEdit">编辑</van-button>
        </div>
    </van-popup>
    <Aside />
</template>

<script setup lang="ts">
import { nextTick, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import { showToast } from 'vant';
import { useRoute } from 'vue-router';
import type { UploaderFileListItem } from 'vant';
import { fetchHistory, sendMessage, editAiMessage } from '../service/api';
import Aside from '../components/aside.vue';
import proxy from '../config/host';
import Editor from '../components/editor.vue';
import useRecorder from '../utils/useRecorder';
import useChat from '../store/useChat';
import useAside from '../store/useAside';
import 'highlight.js/styles/github.css'; // 可替换为其他主题样式
import MessageItem from '../components/messageItem.vue';

const route = useRoute();
const asideStore = useAside();
const chatStore = useChat();
const env = (import.meta.env.MODE || 'development') as keyof typeof proxy;
const API_HOST = proxy[env].chatApi;

interface PreviewImage {
    file: File;
    url: string;
}

const data = reactive({
    messageList: [] as Array<{
        name: string;
        avatar: string;
        right: boolean;
        content: string;
        type: string;
        think?: string;
        id: number; // 添加id字段以支持编辑功能
    }>,
    inputValue: '',
    userInfo: {
        avatarUrl: '',
        username: '',
        userType: 1,
        id: 0,
    },
    isWaiting: false,
    isThinking: false,
    isSpeaking: false,
    imageList: [] as PreviewImage[],
    current_chat_id: undefined as number | undefined,
    showEdit: false,
    editIndex: -1 as number,
    editValue: '',
});

// 上传后处理逻辑
function onAfterRead(file: UploaderFileListItem | UploaderFileListItem[]) {
    const files = Array.isArray(file) ? file : [file];

    files.forEach(item => {
        const f = item.file;
        if (!f) return;

        const url = item.content || URL.createObjectURL(f);
        data.imageList.push({ file: f, url });
    });
}

// 删除图片
function removeImage(index: number): void {
    data.imageList.splice(index, 1);
}
const SSEStatus = ref(false);

// 语音输入
const { canvasEl, startRecording, stopRecording } = useRecorder();
const initData = () => {
    data.messageList = [];
    data.inputValue = '';
    data.isSpeaking = false;
    data.isWaiting = false;
    data.imageList = [];
    data.current_chat_id = route.query.chatId ? Number(route.query.chatId as string) : undefined;
};

console.log(route.query.chatId);

const main = ref();
const scrollToBottom = () => {
    nextTick(() => {
        // console.log('@@@ before checkDom');
        // checkDom();
        main.value.scrollTop = main.value.scrollHeight - main.value.clientHeight;
        console.log(
            '@@@ scroll To bottom top is',
            main.value.scrollTop,
            ' target is ',
            main.value.scrollHeight - main.value.clientHeight,
        );
    });
};
class GPTConnect {
    eventSource: EventSource | null = null;

    question: string | null = null;

    connect() {
        data.isThinking = true;
        data.isWaiting = true;
        data.inputValue = '';
        data.messageList.push({
            name: '',
            avatar: '',
            right: false,
            content: '',
            think: '',
            type: 'text',
            id: -1,
        });
        scrollToBottom();
        const url = `${API_HOST}/chat/?UserID=${data.userInfo.id}&HistoryID=${data.current_chat_id}&Content=e`; // 历史遗留问题，content不能为空，但content已无用处
        this.eventSource = new EventSource(url);
        console.log('尝试建立sse连接', url);
        this.eventSource.onopen = () => {
            console.log('SSE open');
            console.log('url', url);
            SSEStatus.value = true;
            data.messageList[data.messageList.length - 1].content = '';
        };
        // 监听消息事件
        this.eventSource.onmessage = event => {
            // console.log(event)
            // 如果收到数据不为空，且SSEStatus.value为true，说明正在接受sse数据
            if (event.data && SSEStatus.value) {
                const eventData = JSON.parse(event.data);
                if (Object.hasOwn(eventData as object, 'title')) {
                    chatStore.setChatName(data.current_chat_id as number, eventData.title);
                    return;
                }
                if (Object.hasOwn(eventData as object, 'isDone')) {
                    console.log(eventData);
                    if (!eventData.isDone && eventData.newAIMessage[0].type === 'text') {
                        if (eventData.newAIMessage[0].content === '<think>') {
                            data.isThinking = true;
                            data.messageList[data.messageList.length - 1].think = '';
                            return;
                        }
                        if (eventData.newAIMessage[0].content === '</think>') {
                            data.isThinking = false;
                            return;
                        }
                        const type = data.isThinking ? 'think' : 'content';
                        data.messageList[data.messageList.length - 1][type] += eventData.newAIMessage[0].content;
                        // console.table(data.messageList[data.messageList.length - 1])
                    }
                }
            }
        };
        // 监听错误事件
        this.eventSource.onerror = error => {
            console.error('SSE连接出错:', error);
            this.eventSource?.close(); // 关闭连接
            console.log('close');
            // showToast('连接错误')

            SSEStatus.value = false;
            data.isWaiting = false;
            // location.reload()
        };
    }

    close() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
            SSEStatus.value = false;
            data.isWaiting = false;
            console.log('SSE连接已关闭');
        }
    }
}
const gptConnect = new GPTConnect();
const sendMesApi = (textMessage: string, imgList: PreviewImage[]) => {
    const promiseList = [];
    if (textMessage !== '') {
        const p = sendMessage({
            chat_id: data.current_chat_id as number,
            content: textMessage,
            type: 'text',
        }).then(() => {
            data.messageList.push({
                name: data.userInfo.username,
                avatar: data.userInfo.avatarUrl,
                right: true,
                content: textMessage,
                type: 'text',
                id: -1, // 这里的id可以在后端返回时更新
            });
        });
        promiseList.push(p);
    }
    if (imgList && imgList.length > 0) {
        imgList.forEach(img => {
            const p = sendMessage({
                chat_id: data.current_chat_id as number,
                content: img.url,
                type: 'image',
            }).then(() => {
                data.messageList.push({
                    name: data.userInfo.username,
                    avatar: data.userInfo.avatarUrl,
                    right: true,
                    content: img.url,
                    type: 'image',
                    id: -1, // 这里的id可以在后端返回时更新
                });
            });
            promiseList.push(p);
        });
    }
    Promise.all(promiseList).then(() => {
        gptConnect.connect();
    });
};
const fetchHistoryMessage = async () => {
    fetchHistory({
        chat_id: data.current_chat_id as number,
        limit: 100,
    }).then(res => {
        // 如果没有历史记录
        console.log(res);
        res.data.chat_history_list = res.data.chat_history_list ?? [];
        if (res.data.chat_history_list.length === 0) {
            console.log('@@@没有历史记录', chatStore.initMessage);
            if (chatStore.initMessage.text === '' && chatStore.initMessage.imgList.length === 0) {
                showToast('没有历史记录，重新创建聊天');
                chatStore.deleteChat(data.current_chat_id as number);
                chatStore.newChat();
            }
            sendMesApi(chatStore.initMessage.text, chatStore.initMessage.imgList);
            console.log(data.messageList);
        } else {
            res.data.chat_history_list.forEach(msg => {
                const name = msg.role === 'user' ? data.userInfo.username : '';
                const avatar = msg.role === 'user' ? data.userInfo.avatarUrl : '';
                const right = msg.role === 'user';
                const content = msg.role === 'assistant' ? msg.content.split(/<\/?think>/)[2] : msg.content;
                const think = msg.role === 'assistant' ? msg.content.split(/<\/?think>/)[1] : '';
                const id = msg.message_id;
                const { type } = msg;
                data.messageList.push({
                    name,
                    avatar,
                    right,
                    content,
                    type,
                    think,
                    id,
                });
            });
            if (data.messageList[data.messageList.length - 1].right === true) {
                console.log('@@@最后一条消息是用户发送的，重新连接SSE');
                gptConnect.connect();
            }
        }
        scrollToBottom();
    });
};

const handleSendMessage = async () => {
    console.log('click');
    if (data.inputValue.trim() === '' && data.imageList.length === 0) {
        showToast('不能发送空内容');
        return;
    }
    console.log(data.inputValue);
    if (route.path === '/') {
        chatStore.initNewChat(data.inputValue.trim(), data.imageList);
        data.inputValue = '';
        return;
    }
    if (!data.isWaiting) {
        sendMesApi(data.inputValue, data.imageList);
        data.inputValue = '';
        data.imageList = [];
    } else {
        showToast('上一个问题还在回答中');
    }
};

const handleSpeak = () => {
    data.isSpeaking = true;
    startRecording();
};
const finishSpeak = () => {
    data.isSpeaking = false;
    stopRecording().then(async (res: Blob) => {
        // 将音频Blob转换为ArrayBuffer
        const arrayBuffer = await res.arrayBuffer();

        // 使用AudioContext解码为PCM
        const audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)({ sampleRate: 44100 });
        const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

        // 获取原始PCM数据（Float32Array），这里只取第一个声道
        const float32 = audioBuffer.getChannelData(0);

        // 重采样到8000Hz
        function resampleBuffer(buffer: Float32Array, fromSampleRate: number, toSampleRate: number) {
            const ratio = fromSampleRate / toSampleRate;
            const newLength = Math.round(buffer.length / ratio);
            const result = new Float32Array(newLength);
            for (let i = 0; i < newLength; i += 1) {
                result[i] = buffer[Math.round(i * ratio)];
            }
            return result;
        }
        const resampled = resampleBuffer(float32, audioBuffer.sampleRate, 8000);

        // 转换为16bit PCM
        function floatTo16BitPCM(input: Float32Array) {
            const output = new DataView(new ArrayBuffer(input.length * 2));
            for (let i = 0; i < input.length; i += 1) {
                let s = Math.max(-1, Math.min(1, input[i]));
                s = s < 0 ? s * 0x8000 : s * 0x7fff;
                output.setInt16(i * 2, s, true);
            }
            return output.buffer;
        }
        const pcm16Buffer = floatTo16BitPCM(resampled);

        // 生成Blob
        const pcmBlob = new Blob([pcm16Buffer], { type: 'audio/pcm' });

        // 浏览器下载pcm文件
        const url = URL.createObjectURL(pcmBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'audio.pcm';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        // 你可以在这里上传pcmBlob到后端
        // 例如: uploadAudio(pcmBlob)
    });
};
const cancelSpeak = () => {
    data.isSpeaking = false;
    stopRecording();
};

const handleEditMessage = (index: number) => {
    console.log('@@@ handleEditMessage', index);
    data.showEdit = true;
    data.editIndex = index;
    data.editValue = data.messageList[index].content;
};

const cancelEdit = () => {
    data.showEdit = false;
    data.editIndex = -1;
    data.editValue = '';
};
const confirmEdit = () => {
    const oldMessage = data.messageList[data.editIndex];
    const think = oldMessage.think || '';
    const reqContent = `<think>${think}</think>${data.editValue}`;
    editAiMessage({
        chat_id: data.current_chat_id as number,
        message_id: data.messageList[data.editIndex].id,
        content: reqContent,
    }).then(() => {
        data.messageList[data.editIndex].content = data.editValue;
        data.showEdit = false;
        data.editIndex = -1;
        data.editValue = '';
    });
};

watch(
    () => route.query,
    newVal => {
        initData();
        gptConnect.close();
        console.log('@@@ watch route query', newVal);
        if (newVal.chatId) {
            data.current_chat_id = Number(newVal.chatId as string);
            fetchHistoryMessage();
        }
    },
);

onMounted(async () => {
    initData();
    chatStore.setChatList();
    console.log('@@@ mounted');
    const userInfo = JSON.parse(localStorage.getItem('userInfo') as string);
    data.userInfo.avatarUrl = userInfo.avatarUrl;
    data.userInfo.username = userInfo.username;
    data.userInfo.userType = userInfo.userType;
    data.userInfo.id = userInfo.id;
    data.current_chat_id = route.query.chatId ? Number(route.query.chatId as string) : undefined;
    if (route.path !== '/') {
        console.log('@@@聊天内');
        fetchHistoryMessage();
        console.log();
    }
});
onUnmounted(() => {
    gptConnect.close();
});
</script>

<style scoped>
.root {
    width: 100vw;
    height: 100vh;
    display: flex;

    flex-direction: column;
    justify-content: space-between;

    align-content: stretch;
}

.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: static;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px 20px;
}

.header h1 {
    font-size: 20px;
    font-weight: 600;
    color: rgba(93, 93, 93);
}

.textarea {
    box-sizing: border-box;
    width: 80%;
    height: auto;
    resize: none;

    padding: 0px 10px;
    padding-top: 8px;

    border-radius: 5px;

    font-size: 15px;
    line-height: 15px;
}

.main {
    width: 100%;
    /* height: 80%; */
    overflow-y: auto;
    /* background-color:brown; */
}

.input-btn {
    box-sizing: border-box;
    width: 40px;
    height: 30px;

    border-radius: 5px;
    border: 1px solid #686767;

    margin-left: auto;

    font-size: 13px;
}

.footer {
    /* background-color: blueviolet; */
    width: 100%;
    /* height: 20%; */
    /* max-height: 50%; */
    /* position: absolute;
    bottom: 0%; */
    /* border-top: 1px solid #a6a6a6; */
}

.virtual-box {
    width: 80%;
    visibility: hidden;
    padding: 0px 10px;
    padding-top: 8px;
    font-size: 15px;
    line-height: 15px;

    height: 100px;
    position: absolute;
}

.input {
    margin-bottom: 10px;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    margin-top: 10px;
}
</style>
